module.exports = __webpack_public_path__ + "img/614.Broken_chair.ae0b013e.svg";